"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ICEventQueryUtil = exports.QueryEventVariantSpecialEventNames = void 0;
const Utils_1 = require("src/hello_assets/src/components/system/util/Utils");
const typescriptAddons_1 = require("./typescriptAddons");
const lodash_1 = __importDefault(require("lodash"));
const stringifyEventDescription = (eventDescription, parameters) => {
    let name = eventDescription.name;
    if ((parameters === null || parameters === void 0 ? void 0 : parameters.truncateLength) !== undefined) {
        name = (0, Utils_1.truncateMiddle)(name, parameters.truncateLength);
    }
    return name;
};
const stringifyEventQuery = (eventQuery, ctx) => {
    return stringifyEventDescription(eventQuery.eventDescription, ctx);
};
exports.QueryEventVariantSpecialEventNames = {
    newUser: "New User",
    session: "Active User (Session)",
    anyEvent: "Any Event",
};
const stringifyQueryEventVariant = (queryEventVariant, ctx) => {
    if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "event")) {
        return stringifyEventDescription(queryEventVariant.event.eventDescription, ctx);
    }
    else if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "newUser")) {
        return exports.QueryEventVariantSpecialEventNames.newUser;
    }
    else if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "session")) {
        return exports.QueryEventVariantSpecialEventNames.session;
    }
    else if ((0, typescriptAddons_1.hasOwnProperty)(queryEventVariant, "anyEvent")) {
        return exports.QueryEventVariantSpecialEventNames.anyEvent;
    }
    return undefined;
};
const stringifyQueryEventVariants = (queryEventVariants, ctx) => {
    // console.log("toQueryDescription: query", query)
    const appendDescription = function (isFirstElement, repetitionCounter, variantAsString) {
        let result;
        if (isFirstElement) {
            result = variantAsString;
        }
        else {
            result = ` + ${variantAsString}`;
        }
        if (repetitionCounter > 0) {
            return `${result}  x${repetitionCounter + 1}`;
        }
        else {
            return result;
        }
    };
    const buildDescription = function (queryEventVariants) {
        let repetitionCounter = 0;
        let previousVariantAsString = "";
        let isFirstElement = true;
        let result = '';
        lodash_1.default.each(queryEventVariants, function (nextQueryEventVariant) {
            const nextVariantAsString = stringifyQueryEventVariant(nextQueryEventVariant, ctx) || "";
            if (lodash_1.default.isEqual(nextVariantAsString, previousVariantAsString)) {
                repetitionCounter++;
            }
            else {
                if (previousVariantAsString) {
                    result += appendDescription(isFirstElement, repetitionCounter, previousVariantAsString);
                    isFirstElement = false;
                }
                repetitionCounter = 0;
                previousVariantAsString = nextVariantAsString;
            }
        });
        return result + appendDescription(isFirstElement, repetitionCounter, previousVariantAsString);
    };
    return buildDescription(queryEventVariants);
};
exports.ICEventQueryUtil = {
    stringifyEventDescription: stringifyEventDescription,
    stringifyEventQuery: stringifyEventQuery,
    stringifyQueryEventVariant: stringifyQueryEventVariant,
    stringifyQueryEventVariants: stringifyQueryEventVariants,
};
